import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e8b389a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { style: {"margin-bottom":"16px"} }
const _hoisted_4 = { class: "top_layout" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top_left" }, "题目", -1))
const _hoisted_6 = { class: "top_right" }
const _hoisted_7 = { class: "top_right_ans" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top_select" }, null, -1))
const _hoisted_9 = { class: "con_middle_text" }
const _hoisted_10 = { class: "con_base_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_text" }, "题目：", -1))
const _hoisted_12 = { class: "item_text" }
const _hoisted_13 = { class: "con_base_item configure" }
const _hoisted_14 = {
  key: 0,
  class: "con_add"
}

import { ref, computed, reactive, unref } from 'vue';
import { Input, Select, Checkbox, Button, Tooltip, Empty, message } from 'ant-design-vue';
import {
  DownOutlined,
  UpOutlined,
  PlusCircleFilled,
  MinusCircleFilled,
  CheckOutlined,
  FileAddOutlined,
  QuestionCircleFilled,
} from '@ant-design/icons-vue';
import { Options, FormType, DataType, Imodal, AnswerTurnClass } from '../type';
import SvgIcon from '@/components/SvgIcon.vue'; // svg component
import CDelModal from '@/components/CDelModal.vue';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { emptyDataSec } from '@/assets';
import axios from '@/api';
import { useRoute } from 'vue-router';

interface IPorp {
  dataForm: DataType[];
  viewType: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateView',
  props: {
    dataForm: null,
    viewType: null
  },
  emits: ['click:back', 'click:save'],
  setup(__props: any, { emit }) {

const props = __props as {
  dataForm: DataType[];
  viewType: number;
};

const aButton = Button;
const aInput = Input;
const aSelect = Select;
const aCheckbox = Checkbox;
const aTooltip = Tooltip;
const aEmpty = Empty;

const route = useRoute();
const studioId = route.params.studioId;


const goBack = () => {
  emit('click:back');
};

const Opeions: Options[] = [
  { label: '单选题', value: 1 },
  { label: '多选题', value: 2 },
];

const form = ref<FormType>({
  select: undefined,
  keywords: '',
  check: false,
});

// 选择标记
const selectKeys = ref({});
const getSelectId = computed(() => {
  const selectArr = Array<any>();
  Object.keys(selectKeys.value).forEach((e) => {
    if (selectKeys.value[e] === true) {
      selectArr.push(e);
    }
  });
  return selectArr;
});
const changeSelected = () => {
  subject.value.map((e) => (selectKeys.value[e.id] = e.check));
  const check = computed(() => (getSelectId.value.length === subject.value.length ? true : false));
  form.value.check = check.value;
};
const changeSelectedAll = () => {
  if (form.value.check) {
    Object.keys(selectKeys.value).forEach((e) => (selectKeys.value[e] = true));
    subject.value.forEach((e) => (e.check = true));
  } else {
    Object.keys(selectKeys.value).forEach((e) => (selectKeys.value[e] = false));
    subject.value.forEach((e) => (e.check = false));
  }
};
const getSelected = computed(() => Boolean(!getSelectId.value.join(',')));

// 显示编辑部分
const clickEditor = (item: DataType) => {
  item.showEditor = !item.showEditor;
};

const letters = ref<string[]>([]);
for (let i = 0; i < 26; i++) {
  letters.value.push(String.fromCharCode(65 + i));
}
const subject = ref<DataType[]>([]);

subject.value = unref(props.dataForm);
subject.value.map((e) => (selectKeys.value[e.id] = false));

const creatSubject = () => {
  subject.value.push({
    title: ' ',
    answerArr: [
      { answer: ' ', answerTrue: false },
      { answer: ' ', answerTrue: false },
      { answer: ' ', answerTrue: false },
      { answer: ' ', answerTrue: false },
    ],
    check: false,
    type: 1,
    num: 0,
    mustRight: false,
    message: false,
    showdetails: false,
    showEditor: true,
  });
};
const addToAnswer = (item: DataType) => {
  item.answerArr.push({ answer: ' ', answerTrue: false });
};
const reduceAnswer = (index: number, o: number) => {
  subject.value[index].answerArr.splice(o, 1);
};
// 删除
const delModal = reactive<Imodal>({
  title: '删除',
  visible: false,
  loading: false,
});
const delIndex = ref();
const openDelModal = (index: number) => {
  delIndex.value = index;
  delModal.visible = !delModal.visible;
};
const deleteList = () => {
  subject.value.splice(delIndex.value, 1);
  delModal.visible = false;
};

const trueFrequency = (index: number, o: number) => {
  if (subject.value[index].type === 1) {
    if (subject.value[index].answerArr[o].answerTrue) {
      subject.value[index].answerArr[o].answerTrue = false;
    } else {
      subject.value[index].answerArr.forEach((item) => (item.answerTrue = false));
      subject.value[index].answerArr[o].answerTrue = true;
    }
  }
};
// 保存
const save = useDebounce((item: DataType, index: number) => {
  const arr = item.answerArr.map((e) => new AnswerTurnClass(e));
  let result: number[] = [];
  arr.forEach((item, index) => {
    if (item.answerTrue) {
      result.push(index);
    }
  });
  const data = {
    studio_id: studioId,
    title: item.title,
    option: JSON.stringify(arr),
    answer_result: result.join(','),
    answer_type: item.type,
    answer_require: Number(item.mustRight),
    answer_tip: Number(item.message),
    id: item.id ? item.id : undefined,
  };
  axios.liveAnswer
    .answerSubjectSave(data)
    .then((res) => {
      item.showdetails = true;
      item.showEditor = false;
      subject.value[index].id = res.data.data.id;
      emit('click:save');
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
});

const dragDrop = (ev: any) => {
  ev.stopPropagation();
  ev.preventDefault();
  ev.dataTransfer = ev.originalEvent.dataTransfer;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(aButton), {
            class: "header_btn con_middle_btn",
            onClick: goBack
          }, {
            default: _withCtx(() => [
              _createTextVNode("返回列表")
            ]),
            _: 1
          })
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subject.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "content",
          key: index
        }, [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["con_top", { actived: item.check }])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h4", null, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.answerArr, (i, o) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["top_right_ans_wer", { con_middle_icon: i.answerTrue }]),
                      key: o
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(letters.value[o]), 1),
                      _createTextVNode("." + _toDisplayString(i.answer) + "  ", 1),
                      _withDirectives(_createVNode(_unref(CheckOutlined), { class: "con_middle_icon" }, null, 512), [
                        [_vShow, i.answerTrue]
                      ])
                    ], 2))
                  }), 128))
                ])
              ])
            ]),
            _hoisted_8
          ], 2), [
            [_vShow, item.showdetails]
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["con_middle", { actived: item.check }])
          }, [
            _createElementVNode("div", null, [
              _createTextVNode(" 题型："),
              _createElementVNode("span", _hoisted_9, _toDisplayString(Opeions[item.type - 1].label), 1),
              _createTextVNode("答题次数："),
              _createElementVNode("span", null, _toDisplayString(item.num) + "次", 1)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_unref(aButton), {
                class: _normalizeClass(["con_middle_rig", { con_middle_btn: item.showEditor }]),
                onClick: ($event: any) => (clickEditor(item))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 题目编辑 "),
                  _withDirectives(_createVNode(_unref(DownOutlined), { class: "icon" }, null, 512), [
                    [_vShow, !item.showEditor]
                  ]),
                  _withDirectives(_createVNode(_unref(UpOutlined), { class: "con_middle_icon" }, null, 512), [
                    [_vShow, item.showEditor]
                  ])
                ]),
                _: 2
              }, 1032, ["class", "onClick"]),
              _withDirectives(_createVNode(_unref(aButton), {
                class: "con_middle_rig",
                onClick: ($event: any) => (openDelModal(index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 移除")
                ]),
                _: 2
              }, 1032, ["onClick"]), [
                [_vShow, subject.value.length > 1]
              ]),
              _createVNode(_unref(aButton), {
                class: "con_middle_btn",
                onClick: ($event: any) => (_unref(save)(item, index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 保存")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ], 2),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["con_base", { actived: item.check }])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_unref(aInput), {
                value: item.title,
                "onUpdate:value": ($event: any) => ((item.title) = $event),
                maxlength: 500,
                class: "con_base_title"
              }, {
                suffix: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title.length) + " / 500 ", 1)
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.answerArr, (i, o) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "con_base_item",
                key: o
              }, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(letters.value[o]) + "：", 1),
                _createVNode(_unref(aInput), {
                  value: i.answer,
                  "onUpdate:value": ($event: any) => ((i.answer) = $event),
                  class: "con_base_answer",
                  maxlength: 500
                }, null, 8, ["value", "onUpdate:value"]),
                _createVNode(_unref(PlusCircleFilled), {
                  class: "con_base_icon",
                  onClick: ($event: any) => (addToAnswer(item))
                }, null, 8, ["onClick"]),
                _withDirectives(_createVNode(_unref(MinusCircleFilled), {
                  class: "con_base_icon",
                  onClick: ($event: any) => (reduceAnswer(index, o))
                }, null, 8, ["onClick"]), [
                  [_vShow, item.answerArr.length > 2]
                ]),
                _createVNode(_unref(aCheckbox), {
                  checked: i.answerTrue,
                  "onUpdate:checked": ($event: any) => ((i.answerTrue) = $event),
                  class: "item_check",
                  onClick: ($event: any) => (trueFrequency(index, o))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("设为正确")
                  ]),
                  _: 2
                }, 1032, ["checked", "onUpdate:checked", "onClick"])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(aSelect), {
                class: "mod_select header_btn",
                value: item.type,
                "onUpdate:value": ($event: any) => ((item.type) = $event),
                options: Opeions,
                placeholder: "单选题"
              }, {
                suffixIcon: _withCtx(() => [
                  _createVNode(SvgIcon, {
                    class: "mod_select_icon",
                    "icon-class": "list_select"
                  })
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value"]),
              _createVNode(_unref(aCheckbox), {
                checked: item.mustRight,
                "onUpdate:checked": ($event: any) => ((item.mustRight) = $event),
                class: "configure"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("必填")
                ]),
                _: 2
              }, 1032, ["checked", "onUpdate:checked"]),
              _createVNode(_unref(aCheckbox), {
                checked: item.message,
                "onUpdate:checked": ($event: any) => ((item.message) = $event),
                class: "configure"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("正确提示")
                ]),
                _: 2
              }, 1032, ["checked", "onUpdate:checked"]),
              _createVNode(_unref(aTooltip), { placement: "right" }, {
                title: _withCtx(() => [
                  _createTextVNode("开启功能后，答题正确，错误，出现相应提示")
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled), { class: "con_base_item_icon" })
                ]),
                _: 1
              })
            ])
          ], 2), [
            [_vShow, item.showEditor]
          ])
        ]))
      }), 128)),
      (!props.viewType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_unref(aButton), {
              type: "primary",
              onClick: creatSubject
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FileAddOutlined), { class: "icon" }),
                _createTextVNode("再来一题")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (subject.value.length === 0)
        ? (_openBlock(), _createBlock(_unref(aEmpty), {
            key: 1,
            class: "empty_wrap",
            image: _unref(emptyDataSec),
            description: "页面暂无数据信息~"
          }, null, 8, ["image"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(CDelModal, {
      visible: delModal.visible,
      centered: "",
      close: () => (delModal.visible = false),
      ok: deleteList
    }, null, 8, ["visible", "close"])
  ], 64))
}
}

})